import { createFileRoute } from "@tanstack/react-router";

import { ActivityCatalog } from "../features/console";

export const Route = createFileRoute("/console/activities/")({
  component: ActivityCatalog,
});
